export const teamMembers = [
  {
    name: '陈浩然',
    role: '创始人 & CEO',
    description: '前4A广告公司创意总监，15年品牌营销经验，服务过超过100个知名品牌',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20modern%20creative%20agency%20style%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20clean%20white%20background%2C%20editorial%20photography&width=400&height=400&seq=team-01&orientation=squarish',
  },
  {
    name: '林晓薇',
    role: '创意合伙人',
    description: '国际广告节金奖得主，擅长品牌策略与创意整合，曾主导多个现象级传播案例',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%2C%20creative%20agency%20style%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20clean%20white%20background%2C%20editorial%20photography&width=400&height=400&seq=team-02&orientation=squarish',
  },
  {
    name: '赵明哲',
    role: '策略总监',
    description: '10年品牌策略咨询经验，前麦肯锡品牌顾问，精通数据驱动的品牌增长策略',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20modern%20strategy%20consultant%20style%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20editorial%20photography&width=400&height=400&seq=team-03&orientation=squarish',
  },
  {
    name: '孙雨萱',
    role: '内容总监',
    description: '资深内容创作者，前头部MCN内容负责人，打造过多个百万粉丝级内容IP',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20creative%20content%20director%20style%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20editorial%20photography&width=400&height=400&seq=team-04&orientation=squarish',
  },
];

export const honors = [
  { name: '2023中国广告长城奖 - 年度创意机构', icon: 'ri-award-line' },
  { name: '2023金投赏商业创意奖 - 金奖', icon: 'ri-trophy-line' },
  { name: '2022中国内容营销大奖 - 年度最佳内容营销机构', icon: 'ri-medal-line' },
  { name: '2022数字营销大赏 - 最佳社交媒体运营', icon: 'ri-star-line' },
  { name: '2021IAI国际广告奖 - 整合营销类金奖', icon: 'ri-shield-star-line' },
  { name: '2020金鼠标数字营销大赛 - 年度创新机构', icon: 'ri-flashlight-line' },
];

export const clients = [
  '华为', '小米', '字节跳动', '阿里巴巴', '京东', '美团', '蔚来汽车', '元气森林',
  '完美日记', '花西子', '三顿半', '泡泡玛特', '喜茶', '瑞幸咖啡', 'Keep', '知乎',
];

export const testimonials = [
  {
    name: '王建国',
    role: '市场总监',
    company: '某头部科技公司',
    content: '与果冻传媒合作三年，他们的专业度和创意能力始终让我们惊喜。每次新品发布的全案策划都超出预期，已经成为我们最信赖的营销合作伙伴。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20avatar%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    name: '李雪琴',
    role: '品牌总监',
    company: '某知名消费品集团',
    content: '果冻传媒对品牌的理解深度非常打动我。他们不止是执行者，更是策略伙伴。帮我们重塑品牌定位后，消费者认知度和好感度都有了质的飞跃。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20avatar%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    name: '张伟',
    role: 'CEO',
    company: '某新锐消费品牌',
    content: '从0到1的阶段，果冻传媒给了我们巨大的帮助。尤其是短视频内容策略，让我们在预算有限的情况下实现了高效的品牌曝光和用户增长。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20avatar%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
];

export const faqs = [
  {
    question: '果冻传媒的服务流程是怎样的？',
    answer: '我们的服务流程分为五个阶段：需求沟通与诊断 → 策略方案制定 → 创意内容生产 → 执行落地与投放 → 数据复盘与优化。每个阶段都有专业的团队负责，确保项目高效推进。',
  },
  {
    question: '短视频制作的周期一般是多久？',
    answer: '根据项目复杂度和需求不同，单条短视频的制作周期通常为3-7个工作日。系列化内容或大型拍摄项目需要更长的制作周期，我们会在项目启动前与您明确具体的时间规划。',
  },
  {
    question: '果冻传媒服务过哪些行业的客户？',
    answer: '我们服务的客户覆盖科技、消费品、美妆、食品饮料、教育、汽车、金融等多个行业，积累了丰富的跨行业品牌营销经验。',
  },
  {
    question: '如何评估营销活动的效果？',
    answer: '我们建立了完善的数据监测与效果评估体系，从品牌曝光、用户互动、销售转化、品牌资产等多个维度进行追踪和分析。每个项目结束后都会提供详细的数据复盘报告。',
  },
  {
    question: '可以只选择单项服务吗？',
    answer: '当然可以。我们既提供全案整合营销服务，也提供短视频制作、社交媒体运营、广告策划等单项服务。您可以根据实际需求灵活选择。',
  },
];